// Sidebar.jsx
import React from "react";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import logo from "assets/img/logo/logo.png";
import routes from "routes.js";

const Sidebar = ({ open, onClose, userRole }) => {
  // Filter routes based on role
const filteredRoutes = routes.filter((route) => {
  if (route.layout !== "/admin") return false;
  if (route.hideInSidebar) return false; 
  if (!route.allowedRoles) return true;
  if (!userRole) return false;
  if (Array.isArray(route.allowedRoles)) {
    return route.allowedRoles.includes(userRole);
  }
  return route.allowedRoles === userRole;
});


  return (
    <div
      className={`fixed z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl transition-all dark:bg-navy-800 dark:text-white ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span className="absolute right-4 top-4 cursor-pointer xl:hidden" onClick={onClose}>
        <HiX />
      </span>

      <div className="mx-[56px] mt-[50px] flex items-center">
        <img className="m-auto h-20" src={logo} alt="Logo" />
      </div>
      <div className="mb-7 mt-[58px] h-px bg-gray-300 dark:bg-white/30" />
      <ul className="mb-auto pt-1">
        <Links routes={filteredRoutes} onClick={onClose} />
      </ul>
    </div>
  );
};

export default Sidebar;
